import formatDateInLocalTimezone from '../../utils/dateFormatting'

const LastEditedCell = () => {
  return ({ last_edited_timestamp, last_edited_by }) => {
    if (!last_edited_timestamp) {
      return null
    }

    return formatDateInLocalTimezone(last_edited_timestamp) + ' by ' + last_edited_by
  }
}

export default LastEditedCell
